// src/firebase-config.js
import { initializeApp } from 'firebase/app';
import { getDatabase, get, ref} from 'firebase/database';

const firebaseConfig = {
  databaseURL: "https://innovavaccer-site-default-rtdb.firebaseio.com", // e.g., https://<databaseName>.<region>.firebasedatabase.app
};

export async function getUserByEmail(email) {
    const emailKey = email.replaceAll("@", "ATTHERATE").replaceAll(".", "DOT")
    const app = initializeApp(firebaseConfig);
    const database = getDatabase(app);
    const parentKeyRef = await get(ref(database, `users/${emailKey}/file`));
    

    // if (parentKeyRef.exists()) {
    //     parentKeyRef.forEach((x)=>{
    //         console.log(x.val())
    //     })
    // }
    if (parentKeyRef.exists()){
        return Object.values(parentKeyRef.val()).slice(-1)[0]['seatno']
        
    } else {
        return -1
    }
}


